import { ShieldCheck } from "lucide-react";

export const BrandHeader = ({ contractor }) => {
  const initials = contractor.company_name.split(" ").slice(0, 2).map((w) => w[0]).join("");
  const trust = contractor.trust_line || "Free, no-obligation project estimate";
  return (
    <div className="flex items-center gap-3.5" data-testid="contractor-brand-header">
      {contractor.logo_url ? (
        <img src={`${process.env.REACT_APP_BACKEND_URL}${contractor.logo_url}`} alt={contractor.company_name}
          className="h-14 w-14 rounded-2xl border border-slate-200 bg-white object-cover shadow-soft" data-testid="contractor-logo" />
      ) : (
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[color:var(--brand)] text-lg font-bold text-white shadow-soft" data-testid="contractor-logo">{initials}</span>
      )}
      <div className="min-w-0">
        <p className="truncate text-lg font-bold leading-tight tracking-tight text-slate-900" data-testid="contractor-company-name">{contractor.company_name}</p>
        <p className="mt-0.5 flex items-center gap-1 truncate text-sm text-slate-500" data-testid="contractor-trust-line">
          <ShieldCheck className="h-4 w-4 shrink-0 text-emerald-600" />{trust}
        </p>
      </div>
    </div>
  );
};
